import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _ResultStimulus;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { jsx } from '@instructure/emotion';
import { RichContentRenderer } from '@instructure/quiz-rce';
import t from '@instructure/quiz-i18n/format-message';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { withStyleOverrides } from '@instructure/quiz-common';
export var ResultStimulus = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_ResultStimulus = /*#__PURE__*/function (_Component) {
  function ResultStimulus() {
    _classCallCheck(this, ResultStimulus);
    return _callSuper(this, ResultStimulus, arguments);
  }
  _inherits(ResultStimulus, _Component);
  return _createClass(ResultStimulus, [{
    key: "renderStimulusInstructions",
    value: function renderStimulusInstructions() {
      var instructions = this.props.stimulus.instructions;
      if (instructions) {
        return jsx("div", {
          "data-testId": "instructions",
          css: this.props.styles.instructions
        }, jsx("div", {
          css: this.props.styles.instructionsHeader
        }, t('Instructions')), jsx("div", null, instructions));
      }
    }
  }, {
    key: "renderStimulusInfo",
    value: function renderStimulusInfo() {
      var title = this.props.stimulus.title;
      var body = this.props.stimulus.body;
      return jsx("div", {
        css: this.props.styles.info
      }, jsx("div", {
        css: this.props.styles.header
      }, jsx("div", {
        css: this.props.styles.title
      }, title)), jsx(RichContentRenderer, {
        content: body
      }));
    }
  }, {
    key: "renderStimulusItems",
    value: function renderStimulusItems() {
      var _this2 = this;
      return this.props.sessionItem.getNestedEntries().toArray().map(function (sessionItem, i) {
        return jsx("div", {
          key: sessionItem.position,
          css: _this2.props.styles.item
        }, jsx("div", {
          css: _this2.props.styles.connectingLines
        }), jsx("div", {
          "data-testid": "stimulus-item",
          css: _this2.props.styles.stimulusItem
        }, _this2.props.renderItem(sessionItem, i !== 0)));
      });
    }
  }, {
    key: "render",
    value: function render() {
      return jsx("div", null, jsx("div", {
        css: this.props.styles.root
      }, this.renderStimulusInstructions(), jsx("div", {
        css: this.props.styles.stimulusGroup
      }, jsx("div", {
        css: this.props.styles.stimulusInfo
      }, this.renderStimulusInfo()), this.props.stimulus.isPassage === false && jsx("div", {
        css: this.props.styles.items
      }, this.renderStimulusItems()))));
    }
  }]);
}(Component), _defineProperty(_ResultStimulus, "displayName", 'ResultStimulus'), _defineProperty(_ResultStimulus, "componentId", "Quizzes".concat(_ResultStimulus.displayName)), _defineProperty(_ResultStimulus, "propTypes", {
  stimulus: ImmutablePropTypes.record.isRequired,
  sessionItem: ImmutablePropTypes.record.isRequired,
  renderItem: PropTypes.func.isRequired,
  styles: PropTypes.object
}), _ResultStimulus)) || _class);
export default ResultStimulus;